var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0ZM30.4043 12.5752C29.6177 11.8001 28.3505 11.8093 27.5752 12.5957L17.1709 23.1504L12.4248 18.335C11.6494 17.5485 10.3823 17.5393 9.5957 18.3145C8.80912 19.0898 8.79996 20.3569 9.5752 21.1436L15.7471 27.4043C16.1229 27.7855 16.6365 28 17.1719 28C17.707 27.9999 18.22 27.7854 18.5957 27.4043L30.4248 15.4043C31.2 14.6176 31.1909 13.3505 30.4043 12.5752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkcircle);
export default __webpack_public_path__ + "static/media/checkmarkcircle.d316723aacfe2ea7a0b466c8e368baea.svg";
export { ForwardRef as ReactComponent };